import { MonitoringSearchScreen } from "@/app/(app)/monitoring/_components/monitoring-search-screen";

export default function MonitoringNewPage() {
  return <MonitoringSearchScreen />;
}
